export default {
    general: {
        id: null,
        key: null,
        name: 'General'
    },
    legal: {
        id: 1,
        key: 'legal',
        name: 'Legal'
    },
    medicine: {
        id: 2,
        key: 'medicine',
        name: 'Medicine'
    },
    accounting: {
        id: 3,
        key: 'accounting',
        name: 'Accounting'
    },
    psychology: {
        id: 4,
        key: 'psychology',
        name: 'Psychology'
    },
    stylist: {
        id: 5,
        key: 'stylist',
        name: 'Stylist'
    },
    children: {
        id: 7,
        key: 'children',
        name: 'Kids'
    }
};



// WEBPACK FOOTER //
// ./src/lib/discussionTypes.ts